import { Empty, useBreadcrumbRoutes, Wrapper } from '@maxtropy/components';
import { Layout } from 'antd';
import React, { createContext, Key, useState } from 'react';
import styles from './index.module.scss';
import { Dayjs } from 'dayjs';
import EnergyTree from './components/EnergyTree';
import DragResize from '@/components/DragResize';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import RightContent from './components/RightContent';

const { Content, Sider } = Layout;

type RangeValue = [Dayjs | null, Dayjs | null] | null;

export const EnergyAnalysisRankingContext = createContext<{
  groupId?: number;
  unitIds?: Key[];
  setGroupId?: (groupId: number) => void;
  setUnitIds?: (unitIds: Key[] | undefined) => void;
  setTime?: (time: RangeValue) => void;
  time?: RangeValue;
}>({});

const EnergyAnalysisRanking = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [openSider, setOpenSider] = useState(true);
  const [groupId, setGroupId] = useState<number>();
  const [unitIds, setUnitIds] = useState<Key[]>();

  // 初始值
  const [siderWidth, setSiderWidth] = useState(260);
  // 拖拽状态
  const [dragStatus, setDragStatus] = useState(false);

  const dragChange = (width: number) => {
    if (openSider) {
      setSiderWidth(width);
    }
  };

  return (
    <Wrapper routes={breadcrumbRoutes?.routes} hasPadding={false}>
      <EnergyAnalysisRankingContext.Provider value={{ groupId, unitIds, setGroupId, setUnitIds }}>
        <Layout className={styles.layout}>
          <Sider
            className={styles.siderDemo}
            width={openSider ? siderWidth : 0}
            style={{ transition: dragStatus ? 'none' : 'all 0.2s' }}
          >
            <DragResize init={260} dragChange={dragChange} dragStatus={setDragStatus} />
            <EnergyTree />
          </Sider>
          <Content className={styles.content} style={{ marginLeft: openSider ? 10 : 0 }}>
            <div className="toggleBtn" style={{ left: openSider ? -30 : 0 }} onClick={() => setOpenSider(!openSider)}>
              {openSider ? <LeftOutlined /> : <RightOutlined />}
            </div>
            <div style={{ height: 'calc(100vh - 128px)', overflowY: 'auto' }}>
              {groupId ? <RightContent /> : <Empty className={styles.empty} />}
            </div>
          </Content>
        </Layout>
      </EnergyAnalysisRankingContext.Provider>
    </Wrapper>
  );
};

export default EnergyAnalysisRanking;
